export const config = {
  BACKEND_API_URL: process.env.REACT_APP_BACKEND_API_URL || "http://localhost:5000",
  FRONTEND_URL: process.env.REACT_APP_FRONTEND_URL || "http://localhost:3000",
};